export default {
  dashboard: "لوحة التحكم",
  perfectMoney: {
    mainTitle: "Perfect Money",
    buy: "شراء Perfect Money",
    sell: "بيع Perfect Money"
  },
  order: "تسجيل الطلب",
  orderProcess: {
    depositProcess: "إيداع",
    offlineDepositProcess: "إيداع",
    depositResubmitProcess: "المحافظ",
    withdrawalProcess: "سحب",
    withdrawalRialProcess: "سحب",
    withdrawalCryptoProcess: "سحب",
    exchangeProcess: "تبادل",
    transferProcess: "تحويل"
  },
  walletOrder: "المحافظ",
  tickets: {
    mainTitle: "التذاكر",
    createTicket: "التذاكر",
    singleTicket: "التذاكر",
    ticketList: "التذاكر"
  },
  gifts: "الهدايا",
  referral: "ادعو الأصدقاء",
  operations: {
    deposit: "المحافظ",
    withdrawal: "المحافظ",
    exchange: "التبادل",
    transfer: "المحافظ"
  },
  transactionOrder: {
    deposits: "تاريخ المعاملات",
    withdrawals: "تاريخ المعاملات",
    exchanges: "تاريخ المعاملات",
    transfers: "تاريخ المعاملات"
  },
  account: "إعدادات الحساب",
  Markets: {
    market: "الأسواق"
  }
};
